const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_SPECIAL } = require('../../constants/Split');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
module.exports = {
    cubo: 'cubo_fichas',
    title: 'Dados Gerais de Atendimento',
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_ATENDIMENTO_TURNO,
        Atributos.F_ATENDIMENTO_DATA_DIA_SEMANA,
        Atributos.F_ATENDIMENTO_DATA_MES_ROTULO,
        Atributos.F_ATENDIMENTO_LOCAL_ATENDIMENTO,
        Atributos.F_ATENDIMENTO_MEIO_ATENDIMENTO,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    nextPage: '/dados-exposicao-vitima-humana',
    backPage: '/solicitante',
    charts: [
        {
            title: 'ATENDIMENTO DE ACORDO COM MÊS',
            description: 'ATENDIMENTO DE ACORDO COM MÊS.',
            type: 'ApexLineChart',
            w: 2,
            selectDimensions: [Atributos.F_ATENDIMENTO_DATA_MES_ROTULO, Atributos.QNT],
            filters: [],
            transformations: [],
            uiConfig: {
                enableAnimation: true,
                customLabelsArray: [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro',
                ],
            },
        },
        {
            title: 'LOCAL DE ATENDIMENTO',
            description: 'LOCAL DE ATENDIMENTO.',
            type: 'Pivottable',
            headers: ['Atendimento: Local', 'Atendimento: Meio', 'Quantidade'],
            selectDimensions: [Atributos.F_ATENDIMENTO_LOCAL_ATENDIMENTO, Atributos.F_ATENDIMENTO_MEIO_ATENDIMENTO, Atributos.QNT],
            rows: ['Atendimento: Local'],
            rowOrder: 'value_z_to_a',
            // rowOrder: 'key_a_to_z',
            // aggregatorName: 'Sum as Fraction of Total',
            // vals: ['Quantidade'],
            h: '29vw',
            // aggregatorList: [
            //     {
            //         vals: ['Quantidade'],
            //         aggTitle: 'Quantidade',
            //         aggregatorName: 'Integer Sum',
            //     },
            //     // {
            //     //     vals: ['Quantidade'],
            //     //     aggTitle: '%',
            //     //     aggregatorName: 'Sum as Fraction of Total',
            //     // },
            // ],
            aggregatorList: [
                {
                    aggregatorName: 'Integer Sum',
                    aggTitle: 'Total',
                    vals: ['Quantidade'],
                },
                {
                    aggregatorName: 'Sum as Fraction of Total',
                    aggTitle: '%',
                    vals: ['Quantidade'],
                },
            ],
            enablePercentage: true,
            cols: ['Atendimento: Meio'],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_ATENDIMENTO_LOCAL_ATENDIMENTO],
                    transformation: (value) => {
                        // if (value === 'Outro') return '\u200BOutro';
                        return value;
                    },
                },
            ],
        },
        {
            title: 'ATENDIMENTOS NA SEMANA POR TURNO',
            type: 'ApexColumnChart',
            w: 1,
            selectDimensions: [Atributos.F_ATENDIMENTO_TURNO, Atributos.F_ATENDIMENTO_DATA_DIA_SEMANA, Atributos.QNT],
            filters: [],
            filtersRemote: [],
            transformations: [],
            uiConfig: {
                enableAnimation: true,
                // totalDisplayState: 'total', // 'total' | 'parts'
                orderDirection: 'asc',
                orderType: 'count',
                customLabelsArray: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
            },
            // Traz um gráfico em colunas mostrando a situação dos exames de dermatologia por ano. Uma barra contém a contagem de exames "sem laudo" e a outra barra traz a contagem de exames "com laudo".
            // Este card pode ter seus dados filtrados pela variável "Data do exame" presente no dashboard.
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de vítima/solicitação',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
